/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

import React from "react";

import NAV from "../nav";

import SoftwareSubnav from "../../components/software/SoftwareSubnav";
import SoftwareHero from "../../components/software/SoftwareHero";
import SoftwareTrustBar from "../../components/software/SoftwareTrustBar";
import SoftwareProducts from "../../components/software/SoftwareProducts";
import SoftwareEcosystem from "../../components/software/SoftwareEcosystem";
import SoftwareCTA from "../../components/software/SoftwareCTA";
import SoftwareComingSoon from "../../components/software/SoftwareComingSoon";

const SoftwareHome = () => {

  return (

    <div
      className="
        bg-surface
        text-on-surface
        font-body
      "
    >

      {/* ==========================================
          HERO
      ========================================== */}

      <div className="relative">

        <NAV activetag="software" />

        {/* Match MF spacing */}

        {/*<div className="pt-[10px]">*/}
        <section id="overview">
          <SoftwareSubnav
            active="overview"
          />

          <SoftwareHero />

        {/*</div>*/}
        </section>
      </div>


      {/* ==========================================
          TRUST BAR
      ========================================== */}

      <SoftwareTrustBar />


      {/* ==========================================
          PRODUCTS
      ========================================== */}
      <section id="products">
      <SoftwareProducts />
      </section>

      {/* ==========================================
          ECOSYSTEM
      ========================================== */}

      <SoftwareEcosystem />


      {/* ==========================================
          ROADMAP
      ========================================== */}
      <section id="roadmap">
      <SoftwareComingSoon />
      </section>


      {/* ==========================================
          FINAL CTA
      ========================================== */}

      <SoftwareCTA />

    </div>

  );

};

export default SoftwareHome;